import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import WriteActionButtons from './WriteActionButtons';
import { updateProject, writeProject } from '../../modules/project/projectWriteSlice';

const WriteActionButtonsContainer = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    // const { title, body, tags, project, projectError, originalProjectId } = useSelector(({ projectWrite }) => ({
    //     title: projectWrite.title,
    //     body: projectWrite.body,
    //     tags: projectWrite.tags,
    //     project: projectWrite.project,
    //     projectError: projectWrite.projectError,
    //     originalProjectId: projectWrite.originalProjectId,
    // }));
    const title = useSelector(state => state.projectWrite.title);
    const body = useSelector(state => state.projectWrite.body);
    const tags = useSelector(state => state.projectWrite.tags);
    const project = useSelector(state => state.projectWrite.project);
    const projectError = useSelector(state => state.projectWrite.projectError);
    const originalProjectId = useSelector(state => state.projectWrite.originalProjectId);

    const language = useSelector(state => state.language.language);
    const isKR = language === 'KR' ? true : false;
    const isJP = language === 'JP' ? true : false;
    const isEN = language === 'EN' ? true : false;

    const alertText = isKR ? '모든 내용을 입력하세요' : isJP ? 'すべての内容をインプットください。' : isEN ? 'Input all Data' : ''

    // 포스트 등록
    const onPublish = () => {
        const { comment, contractDate, contact } = body;

        if (!comment || !contractDate || !contact) {
            alert(alertText);
            return;
        }
        
        if (originalProjectId) {
            dispatch(updateProject({ title, body, tags, id: originalProjectId}));
            return;
        }
        dispatch(writeProject({ title, body, tags }));
    };

    // 취소
    const onCancel = () => {
        //dispatch(initialize());   // 이게 아니네...
        navigate(-1);
    };

    // 성공 혹은 실패 시 할 작업
    useEffect(() => {
        if (project) {
            // 해당 프로젝트로 이동
            // const { _id } = project;
            // navigate(`/projects/${_id}`);
            
            // 프로젝트 리스트로 이동
            navigate('/projects')
        }
        if (projectError) {
            console.error(projectError);
        }
    }, [dispatch, navigate, project, projectError]);

    return <WriteActionButtons onCancel={onCancel} onPublish={onPublish} isEdit={!!originalProjectId} />;
};

export default WriteActionButtonsContainer;
